import * as React from "react";
const SvgCheck = ({
  title,
  titleId,
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M17.86 28.1 10 20.78l2.84-3 4.82 4.49L27 12l3 2.84z" /></svg>;
export default SvgCheck;